import React, { memo } from 'react'
import PropTypes from 'prop-types'

const VARIANTS = ['positive', 'negative', 'hidden']
const SIZES = ['md', 'sm']

function ActionButton(props) {
  const { children, className, disabled, handleOnClick, variant, size } = props

  return (
    <button
      className={`action-button action-button--${variant} ${className} ${
        size ? `action-button--${size}` : ''
      }`}
      disabled={disabled}
      onClick={handleOnClick}
      type="button"
    >
      <div className="action-button__text">{children}</div>
    </button>
  )
}

ActionButton.propTypes = {
  children: PropTypes.number.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(SIZES),
  variant: PropTypes.oneOf(VARIANTS)
}

ActionButton.defaultProps = {
  className: '',
  disabled: false,
  size: SIZES[0],
  variant: VARIANTS[0]
}

export default memo(ActionButton)
